export default __webpack_public_path__ + "static/media/jennie1.fe36c58d.gif";